import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en_EN';
import es from './es_LA';
import pt from './pt_BR';
import it from './it_IT.json';

Vue.use(VueI18n);

const messages = {
  en: { lang: en },
  es: { lang: es },
  pt: { lang: pt },
  it: { lang: it },
};

const i18n = new VueI18n({
  locale: 'en', // Idioma inicial genérico
  fallbackLocale: 'en',
  messages,
});

export default i18n;
